import { useCallback, useState } from 'react';

import { FilterState } from './types';
import { createInitialFilterState } from './utils';

export const useDealsFilters = () => {
  const [filterState, setFilterState] = useState<FilterState>(createInitialFilterState());

  const updateFilter = useCallback((updates: Partial<FilterState>) => {
    setFilterState((prev) => {
      const newState: FilterState = {
        health: updates.health !== undefined ? updates.health : prev.health,
        owner: updates.owner !== undefined ? updates.owner : prev.owner,
        client: updates.client !== undefined ? updates.client : prev.client,
        business: updates.business !== undefined ? updates.business : prev.business,
        dealType: updates.dealType !== undefined ? updates.dealType : prev.dealType,
        startDate: updates.startDate !== undefined ? updates.startDate : prev.startDate,
        closeDate: updates.closeDate !== undefined ? updates.closeDate : prev.closeDate,
      };

      return newState;
    });
  }, []);

  const clearAllFilters = useCallback(() => {
    setFilterState(createInitialFilterState());
  }, []);

  return {
    filterState,
    updateFilter,
    clearAllFilters,
  };
};
